module.exports = __webpack_public_path__ + "img/zero.e9c024d.svg";